var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10671 7.24683C5.04004 7.24016 4.96004 7.24016 4.88671 7.24683C3.30004 7.1935 2.04004 5.8935 2.04004 4.2935C2.04004 2.66016 3.36004 1.3335 5.00004 1.3335C6.63337 1.3335 7.96004 2.66016 7.96004 4.2935C7.95337 5.8935 6.69337 7.1935 5.10671 7.24683Z",
    stroke: "#5A6385",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77348 9.7065C0.160143 10.7865 0.160143 12.5465 1.77348 13.6198C3.60681 14.8465 6.61348 14.8465 8.44681 13.6198C10.0601 12.5398 10.0601 10.7798 8.44681 9.7065C6.62014 8.4865 3.61348 8.4865 1.77348 9.7065Z",
    stroke: "#5A6385",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c489430b9a4d3108bf53ca8fbb241140.svg";
export { ForwardRef as ReactComponent };